import { useLightMode } from '@/hooks/useLightMode'

import { Checkbox, Box as DarkBox, MapPinIcon } from '@hivewatch/dark'

import {
  checkboxRowNoteStyles,
  checkboxRowStyles,
  checkboxRowTitleStyles,
} from './DarkTourPlansPanel.styles'

export interface DarkCheckpointSelectRowIProps {
  label: string
  subLabel: string
  selected?: boolean
  onChecked?: () => void
}

// Checkbox + FeedItem-style content (pin icon + name + CP-ID note). The
// checked-row highlight lives here, on the row treatment — not in Checkbox.
// The row is a plain box, not a <label>: Checkbox already renders its own
// label, and nesting one inside another is invalid HTML.
export const DarkCheckpointSelectRow = ({
  label,
  subLabel,
  selected = false,
  onChecked,
}: DarkCheckpointSelectRowIProps) => {
  const colorScheme = useLightMode()

  return (
    <DarkBox
      data-testid='tourplan_form_checkpointRow'
      onClick={() => onChecked?.()}
      {...checkboxRowStyles(colorScheme, selected)}
    >
      <Checkbox
        checked={selected}
        colorScheme={colorScheme}
        onChange={() => onChecked?.()}
        onClick={(e) => e.stopPropagation()}
      />
      <DarkBox display='flex' flexDirection='column' gap='2px' minWidth={0}>
        <DarkBox {...checkboxRowTitleStyles(colorScheme)}>{label}</DarkBox>
        <DarkBox {...checkboxRowNoteStyles(colorScheme)}>
          <MapPinIcon colorScheme={colorScheme} size={12} />
          {subLabel}
        </DarkBox>
      </DarkBox>
    </DarkBox>
  )
}
